module.exports = __webpack_public_path__ + "img/icono_share.1fca4faf.svg";